import { render, staticRenderFns } from "./PageShoppingList.vue?vue&type=template&id=a6b807ce&"
import script from "./PageShoppingList.js?vue&type=script&lang=js&"
export * from "./PageShoppingList.js?vue&type=script&lang=js&"
import style0 from "./PageShoppingList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageShoppingList.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcartdetail%2FPageShoppingList%2FPageShoppingList.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports